/* eslint react/no-danger: 0, react-hooks/exhaustive-deps: 0, jsx-a11y/anchor-is-valid: 0, react/no-array-index-key: 0 */
import React, { useEffect, useState } from 'react';
import Observer from 'react-intersection-observer';
import content from '../../content';
import { GAfireEvent } from '../Tracking';
import 'react-app-polyfill/ie11';
import ArrowRightWhite from '../../images/arrow__right-white.svg';
import Button from '../Button';
import 'wicg-inert';

import { fireTag } from '../../libs/analytics';


const scrollIntoViewWithOffset = (selector, offset) => {
	window.scrollTo({
		behavior: 'instant',
		top:
			document.querySelector(selector).getBoundingClientRect().top -
			document.body.getBoundingClientRect().top -
			offset,
	})
}

const StatItem = ({stat, index, isRow, displayVideoOverlay, number}) => (
	<a className={`tile ${isRow ? 'row' : ''}`} href={stat.url} target={`${stat.noBlank ? '' : '_blank'}`} rel="noreferrer"
		onClick={(event) => {

			fireTag('C1',stat.header.toLowerCase());

			if (stat.medium === 'article') {
				window.open(stat.btn.href)
			}
			else if (stat.medium === 'video') {
				if (stat.video) {
					displayVideoOverlay(event);
				}
				else {
					window.open(stat.btn.href)
				}
			}

		}}
		data-video-type={!stat.video ? 'article' : stat.video.videoType}
		data-videoid={stat.video ? stat.video.videoID : null} // vimeo
		data-videopath={stat.video ? stat.video.videoPath : null} // vimeo
		data-captionpath={stat.video ? stat.video.captionPath : null} // vimeo
		aria-label={stat.header}
		role="button"
	>
		<div className="stat-top" aria-hidden="true">
			<div className={`stat-image ${stat.attrib.toLowerCase().replace(/ /g, '-')}`} data-index={number} alt={stat.imgAlt}/>
			{stat.media === 'article' && (
				<p className="cta">Read now <img alt="White Right Arrow" src={ArrowRightWhite}/></p>
			)}
			{stat.media === 'video' && (
				<div className="cta">
					<p className="cta-text">Watch now <img alt="White Right Arrow" src={ArrowRightWhite}/></p>
					<p className="time">
						<time dateTime={stat.time}>
							<span ref={node => node && node.setAttribute('inert', '')}>{stat.time}</span>
						</time>
					</p>
				</div>
			)}
		</div>
		<div className="stat-bottom">
			<p className="header" dangerouslySetInnerHTML={{__html: stat.header}}/>
			<p className="subheader" dangerouslySetInnerHTML={{__html: stat.subheader}}/>
		</div>
	</a>
)

const StatItemEmpty = ({stat, index}) =>

	(
		<div className="tile empty" tabIndex="-1">
			<div className="stat-top">
				<div className="stat-image"/>
				<p className="cta"/>
			</div>
			<div className="stat-bottom">
				<p className="header"/>
				<p className="subheader"/>
			</div>
		</div>)


const VisibleRow = ({visibleTiles, totalTiles, displayVideoOverlay}) => (
	<>
		{
			(() => {
				const elements = [];
				for (let i = 0; i < visibleTiles; i++) {
					if (i < totalTiles) {
						elements.push(<StatItem
							key={i}
							number={i}
							stat={content.sustainability.perspectives.tiles[i]}
							index={i + visibleTiles}
							displayVideoOverlay={displayVideoOverlay}
						/>);
					}
					else {
						elements.push(<StatItemEmpty index={i}/>)
					}
				}
				return elements;
			})()
		}

	</>
)


const DrawerRow = ({visibleTiles, row, tilesPerRow, index, notInert, noBlank, displayVideoOverlay}) => (
	<>
		<div className="drawer-row closed" data-row-count={index} ref={node => node && (!notInert ? node.setAttribute('inert', '') : (node.removeAttribute('inert')))}>

			{(() => {
				const elements = [];
				for (let i = 0; i < tilesPerRow; i++) {
					if (i < row.length) {
						elements.push(<StatItem
							stat={row[i]}
							index={i + visibleTiles}
							key={i}
							isRow
							displayVideoOverlay={displayVideoOverlay}
						/>);
					}
					else {
						if (!noBlank) {
							elements.push(<StatItemEmpty key={i} index={i}/>)
						}
					}
				}
				return elements;
			})()}


		</div>
	</>
)


const Perspectives = props => {
	const [hideInert, setHideInert] = useState(false);

	const chunk = (chunkSize, array) => {
		const R = [];
		for (let i = 0; i < array.length; i += chunkSize)
			R.push(array.slice(i, i + chunkSize));
		return R;
	}

	const drawerConfigSettings = [
		{
			min: 0,
			max: 569,
			onload: 2,
			hidden: 2,
			noBlank: true,
		},
		{
			min: 570,
			max: 767,
			onload: 2,
			hidden: 2,
			noBlank: true,
		},
		{
			min: 768,
			max: 1079,
			onload: 4,
			hidden: 2,
			noBlank: false,
		},
		{
			min: 1080,
			max: 1000000000,
			onload: 5,
			hidden: 3,
			noBlank: false,
		}
	]
	const buttonElShow = document.getElementById('perspectives_button--show');
	const buttonElHide = document.getElementById('perspectives_button--hide');
	let drawerEls = document.querySelectorAll('#sustainability-perspectives .drawer-row');
	let drawerElsOpen = document.querySelectorAll('#sustainability-perspectives .open.drawer-row');
	let drawerElsClosed = document.querySelectorAll('#sustainability-perspectives .closed.drawer-row');
	let allOpen = drawerElsClosed.length === 0;

	useEffect(() => {
		//TODO: Optimize
		drawerEls = document.querySelectorAll('#sustainability-perspectives .drawer-row');
		drawerElsOpen = document.querySelectorAll('#sustainability-perspectives .open.drawer-row');
		drawerElsClosed = document.querySelectorAll('#sustainability-perspectives .closed.drawer-row');


		allOpen = drawerElsClosed.length === 0;


		// if row opened, remove inert
		if (drawerElsOpen.length > 0) {
			drawerElsOpen.forEach(el => {
				el.removeAttribute('inert');
			})
		}
		// Hide View More button on load
		if (!hideInert && buttonElHide) {
			buttonElHide.inert = true;
			setHideInert(true)
		}

	})

	const drawerConfig = drawerConfigSettings.find(o => (window.innerWidth >= o.min && window.innerWidth <= o.max))
	const totalTiles = content.sustainability.perspectives.tiles.length;

	const visibleTiles = drawerConfig.onload;

	const hiddenTiles = [...content.sustainability.perspectives.tiles];
	hiddenTiles.splice(0, drawerConfig.onload)

	const hiddenRows = chunk(drawerConfig.hidden, hiddenTiles);
	const lastHiddenRow = hiddenRows[hiddenRows.length - 1] || [];
	const numberBlankTiles = (drawerConfig.hidden - lastHiddenRow.length === drawerConfig.hidden) ? 0 : drawerConfig.hidden - lastHiddenRow.length;

	const showPerspectivesDrawer = (e) => {


		drawerEls = document.querySelectorAll('#sustainability-perspectives .drawer-row');
		drawerElsOpen = document.querySelectorAll('#sustainability-perspectives .open.drawer-row');
		drawerElsClosed = document.querySelectorAll('#sustainability-perspectives .closed.drawer-row');

		allOpen = drawerElsClosed.length === 0;
		const {innerText} = buttonElShow;

		//If drawer can be opened
		[...drawerEls].forEach(drawerEl => {
			drawerEl.classList.remove('closed');
			drawerEl.classList.add('open');
			drawerEl.removeAttribute('inert');
		})

		fireTag('C2', innerText.toLowerCase());

		//GAfireEvent('isf_C24', {label: innerText})

		buttonElShow.inert = buttonElShow.inert !== 'true';
		buttonElHide.inert = buttonElHide.inert === 'true';

	}

	const hidePerspectivesDrawer = (e) => {
		drawerEls = document.querySelectorAll('#sustainability-perspectives .drawer-row');
		drawerElsOpen = document.querySelectorAll('#sustainability-perspectives .open.drawer-row');
		drawerElsClosed = document.querySelectorAll('#sustainability-perspectives .closed.drawer-row');

		allOpen = drawerElsClosed.length === 0;
		const {innerText} = buttonElHide;

		//If drawer can be closed
		[...drawerEls].forEach(drawerEl => {
			drawerEl.classList.remove('open');
			drawerEl.classList.add('closed');
			drawerEl.setAttribute('inert', '');
		})

		//GAfireEvent('isf_C24', {label: innerText})

		fireTag('C2', innerText.toLowerCase());

		buttonElHide.inert = buttonElHide.inert !== 'true';
		buttonElShow.inert = buttonElShow.inert === 'true';

		scrollIntoViewWithOffset("#sustainability-perspectives", document.querySelector(".sticky-nav").offsetHeight);

	}

	let scrollPerspectives = false;

	useEffect(() => {
		window.addEventListener('scroll',()=>{
			if(window.location.href.includes('/sustainability/') && !scrollPerspectives && document.querySelector('#sustainability-perspectives').getBoundingClientRect().top <= document.querySelector('nav').getBoundingClientRect().height){
				scrollPerspectives = true;
				fireTag('S1');
			}
		});
	},[])


	return (
		<>
			<Observer
				tag='section'
				id="sustainability-perspectives"
				threshold={0.50}
				triggerOnce
				onChange={inView => {
					if (inView) {
						//GAfireEvent('isf_S2');
						//fireTag('S1');
					}
				}}
			>
				<h2 tabIndex="-1" dangerouslySetInnerHTML={{__html: content.sustainability.perspectives.headline}}/>
				<div className="stat-tiles">

					{/* Visible tiles go here. Only show the max number specified in the drawerConfig */}
					<VisibleRow visibleTiles={visibleTiles} totalTiles={totalTiles} displayVideoOverlay={props.displayVideoOverlay}/>

					<Button role="button" buttonID="perspectives_button--show" key="" tabIndex='0' handleClick={() => {
						showPerspectivesDrawer();
					}}
					>
						Load more perspectives
					</Button>

					{/* If more tiles are available for the drawer, create drawer */}
					{
						(totalTiles > visibleTiles && (
							(() => {
								const elements = [];
								hiddenRows.forEach((row, index) => {
									elements.push(
										<DrawerRow key={index} index={index + visibleTiles} row={row} visibleTiles={visibleTiles} hiddenTiles={numberBlankTiles} tilesPerRow={drawerConfig.hidden} noBlank={drawerConfig.noBlank} displayVideoOverlay={props.displayVideoOverlay}/>
									)
								})
								return elements;
							})()
						))
					}

					<Button role="button" buttonID="perspectives_button--hide" key="i" tabIndex='0'
						handleClick={() => {
							hidePerspectivesDrawer();
						}}
					>
						View less
					</Button>
				</div>
			</Observer>
		</>
	);
}

export default Perspectives;
